import axios from "axios";
import { ITestimonialData } from "../types/testimonials";

const API_URL = `${process.env.REACT_APP_API_URL}/testimonials`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

export const fetchTestimonialsTable = async (page: number, limit: number) => {
  const response = await axios.get(`${API_URL}?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response;
};

export const fetchTestimonials = async () => {
  const response = await axios.get(API_URL, { headers: customHeaders });
  return response.data;
};

export const fetchTestimonialById = async (id: string) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};

export const addTestimonial = async (testimonial: ITestimonialData) => {
  const response = await axios.post(API_URL, testimonial, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
};

export const updateTestimonial = async (id: string, updatedTestimonial: ITestimonialData) => {
  const response = await axios.put(`${API_URL}/${id}`, updatedTestimonial, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
};

export const removeTestimonial = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};

export const approveStatusChangeTestimonial = async (id: string,status:boolean) => {
  const response = await axios.put(`${API_URL}/status/${id}`,{status}, { headers: customHeaders });
  return response.data;
};
